export default {
  name: 'payment_history',
  path: '/payment_history',
  component: () =>
    import(/* webpackChunkName: "paymentHistory" */ './index.vue')
}
